var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 58 58"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cube_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h58v58H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cube_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m29 5.906 20 11.547v23.094L29 52.094 9 40.547V17.453L29 5.906Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 5.906 20 11.547Q30.5 28.938 29 29q-1.5.062-20-11.547L29 5.906Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49 17.453v23.094L29 52.094V29l20-11.547Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cube_svg__shadow",
  d: "M49 17.453v23.094L29 52.094V29l20-11.547Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cube_svg__border-right",
  d: "M29 1.287v4.619l20 11.547v23.094L29 52.094v4.619l24-13.857V15.144L29 1.287Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cube_svg__border-left",
  d: "M29 1.287v4.619L9 17.453v23.094l20 11.547v4.619L5 42.856V15.144L29 1.287Z"
}))));
export default SvgCube;